// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"479":"16e46725","720":"af0bdf0e"}[chunkId] + ".chunk.css";
};